import dayjs from "dayjs";
import { devices } from "../components/DeviceComponents";

// download pdf and csv files
export const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType });
  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

// date management
export const renderEUDate = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const renderEUTime = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const renderEUDateTime = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const convertServerToLocalDatetime = (date) => {
  if (date === null || date === undefined) return "";

  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const renderEUDateTimeLong = (date) => {
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: undefined,
  });
};

export const todayDate = () => {
  return dayjs().format("YYYY-MM-DD");
};

export const dateToServer = (date) => {
  const hoursOffset = new Date().getTimezoneOffset() / -60;

  let _date = new Date(date);

  _date.setTime(
    _date.getTime() +
      _date.getTimezoneOffset() * 60 * 1000 +
      hoursOffset * 60 * 60 * 1000
  );

  const month = String(_date.getMonth() + 1).padStart(2, "0");
  const day = String(_date.getDate()).padStart(2, "0");

  let data = `${_date.getFullYear()}-${month}-${day}`;

  return data;
};

export const datetimeToServer = (date) => {
  const hoursOffset = new Date().getTimezoneOffset() / -60;

  let _date = new Date(date);

  _date.setTime(
    _date.getTime() +
      _date.getTimezoneOffset() * 60 * 1000 +
      hoursOffset * 60 * 60 * 1000
  );

  const month = String(_date.getMonth() + 1).padStart(2, "0");
  const day = String(_date.getDate()).padStart(2, "0");
  const hours = String(_date.getHours()).padStart(2, "0");
  const minutes = String(_date.getMinutes()).padStart(2, "0");

  return `${_date.getFullYear()}-${month}-${day} ${hours}:${minutes}:00`;
};

export const renderDateUTC = (date) => {
  const d = new Date(date).toISOString().substring(0, 10);
  return d;
};
export const renderTimeUTC = (date) => {
  return new Date(date).toISOString().substring(11, 19);
};
export const renderDatetimeUTC = (date) => {
  return new Date(date).toISOString().replace("T", " ").substring(0, 19);
};

// returns the displayable version of the profile string (capitalized, no underscores)
export const prettify = (p) => {
  if (p !== null && p !== undefined) {
    let a = p.replace("_", " ");
    return a.charAt(0).toUpperCase() + a.replace("_", " ").slice(1);
  }
  return "null/undefined";
};

export const renderDeviceName = (device_type) => {
  return `${prettify(
    devices.find((el) => el.device_type === device_type).category
  )} / ${prettify(
    devices.find((el) => el.device_type === device_type).h3k_code
  )}`;
};

const USER_UPDATE_FIELDS = [
  "username",
  "email",
  "mobile",
  "first_name",
  "last_name",
  "doctor_id",
  "user_type",
];

const DOCTOR_UPDATE_FIELDS = [
  "first_name",
  "last_name",
  "iban",
  "piva",
  "date_of_birth",
  "is_active",
  "note",
  "address",
  "city",
  "province",
  "cap",
  "address_secondary",
  "city_secondary",
  "province_secondary",
  "cap_secondary",
  "phone",
  "mobile",
  "email",
  "mobile_alert",
  "email_alert",
];

const PATIENT_UPDATE_FIELDS = [
  "first_name",
  "last_name",
  "gender",
  "cf",
  "date_of_birth",
  "height",
  "weight",
  "is_active",
  "history",
  "note",
  "address",
  "city",
  "province",
  "cap",
  "hypertensive",
  "address_secondary",
  "city_secondary",
  "province_secondary",
  "cap_secondary",
  "phone",
  "mobile",
  "email",
  "doctor_id",
];

const SERVICE_UPDATE_FIELDS = [
  "is_active",
  "cr_activation",
  "start_date",
  "end_date",
  "delivery",
  "note1",
  "note2",
];

const SERVICE_CREATE_FIELDS = [
  "service",
  "start_date",
  "end_date",
  "delivery",
  "patient_id",
  "doctor_id",
  "org_id",
  "note1",
  "note2",
];

const TELEVISIT_MUTATION_FIELDS = [
  "date",
  "subject",
  "note",
  "report",
  "send_patient_email",
  "send_patient_sms",
  "send_colleagues_email",
  "send_colleagues_sms",
  "patient_id",
  "doctor_id",
  "org_id",
  "colleague1_id",
  "colleague2_id",
  "colleague3_id",
];

export const normalizeDateOnlyValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "string") {
    return value.includes("T") ? renderDateUTC(value) : value;
  }

  return dateToServer(value);
};

export const normalizeDateTimeValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "string") {
    return value.includes("T") ? renderDatetimeUTC(value) : value;
  }

  return renderDatetimeUTC(value);
};

export const sanitizeUserUpdatePayload = (user) => {
  const payload = {};

  for (const key of USER_UPDATE_FIELDS) {
    if (user?.[key] !== undefined) {
      payload[key] = user[key];
    }
  }

  if (typeof payload.user_type === "string") {
    const normalized = payload.user_type.trim();
    if (normalized === "backend") payload.user_type = 1;
    if (normalized === "medico") payload.user_type = 2;
  }

  return payload;
};

export const sanitizeDoctorUpdatePayload = (doctor) => {
  const payload = {};

  for (const key of DOCTOR_UPDATE_FIELDS) {
    if (doctor?.[key] !== undefined) {
      payload[key] = doctor[key];
    }
  }

  if (payload.date_of_birth !== undefined) {
    payload.date_of_birth = normalizeDateOnlyValue(payload.date_of_birth);
  }

  return payload;
};

export const sanitizePatientUpdatePayload = (patient) => {
  const payload = {};

  for (const key of PATIENT_UPDATE_FIELDS) {
    if (patient?.[key] !== undefined) {
      payload[key] = patient[key];
    }
  }

  if (payload.date_of_birth !== undefined) {
    payload.date_of_birth = normalizeDateOnlyValue(payload.date_of_birth);
  }

  return payload;
};

export const sanitizeServiceUpdatePayload = (service) => {
  const payload = {};

  for (const key of SERVICE_UPDATE_FIELDS) {
    if (service?.[key] !== undefined) {
      payload[key] = service[key];
    }
  }

  if (payload.start_date !== undefined) {
    payload.start_date = normalizeDateOnlyValue(payload.start_date);
  }
  if (payload.end_date !== undefined) {
    payload.end_date = normalizeDateOnlyValue(payload.end_date);
  }

  if (typeof payload.delivery === "string") {
    const normalized = payload.delivery.trim();
    const deliveryMap = {
      ritiro_in_studio: 1,
      consegna_a_casa: 2,
    };
    if (deliveryMap[normalized] !== undefined) {
      payload.delivery = deliveryMap[normalized];
    }
  }

  return payload;
};

export const sanitizeServiceCreatePayload = (service) => {
  const payload = {};

  for (const key of SERVICE_CREATE_FIELDS) {
    if (service?.[key] !== undefined) {
      payload[key] = service[key];
    }
  }

  if (payload.start_date !== undefined) {
    payload.start_date = normalizeDateOnlyValue(payload.start_date);
  }
  if (payload.end_date !== undefined) {
    payload.end_date = normalizeDateOnlyValue(payload.end_date);
  }

  return payload;
};

export const sanitizeTelevisitPayload = (televisit) => {
  const payload = {};

  for (const key of TELEVISIT_MUTATION_FIELDS) {
    if (televisit?.[key] !== undefined) {
      payload[key] = televisit[key];
    }
  }

  if (payload.date !== undefined) {
    payload.date = normalizeDateTimeValue(payload.date);
  }

  return payload;
};

// toast options
export const toastError = {
  position: "bottom-left",
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

export const toastSuccess = {
  position: "bottom-left",
  autoClose: true,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};
